var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18.215 18.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_04_profile-2_px18",
    transform: "translate(0.263 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M5.348,16.9A8.643,8.643,0,0,1,.655,12.248a8.517,8.517,0,0,1,1.939-9.4A8.641,8.641,0,0,1,8.656.386H8.67a8.752,8.752,0,0,1,3.823.888L16.03.069A1.284,1.284,0,0,1,16.443,0a1.256,1.256,0,0,1,.888.367,1.235,1.235,0,0,1,.3,1.29L16.416,5.163A8.6,8.6,0,0,1,8.8,17.548l-.144,0A8.656,8.656,0,0,1,5.348,16.9Zm-4.3-8.055A7.45,7.45,0,0,0,3.277,14.3a7.588,7.588,0,0,0,5.377,2.208H8.78a7.6,7.6,0,0,0,7.483-7.552,7.5,7.5,0,0,0-.878-3.509.518.518,0,0,1-.032-.412l1.288-3.716a.2.2,0,0,0-.05-.215.208.208,0,0,0-.146-.063.239.239,0,0,0-.073.013L12.624,2.33a.549.549,0,0,1-.171.028.53.53,0,0,1-.246-.06,7.662,7.662,0,0,0-3.539-.871H8.655A7.607,7.607,0,0,0,1.051,8.845Zm5.258,1.817A2.532,2.532,0,0,1,8.34,8.193V6.583a.511.511,0,0,1,1.022,0V8.649a.509.509,0,0,1-.511.506,1.508,1.508,0,1,0,1.52,1.507.511.511,0,0,1,1.022,0,2.543,2.543,0,0,1-5.085,0ZM8.326,4.6a.525.525,0,1,1,.525.521A.531.531,0,0,1,8.326,4.6Z",
    transform: "translate(17.701 17.55) rotate(180)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.6fc7930a5fecf14e57ca1954ec90ea05.svg";
export { ForwardRef as ReactComponent };